/*
 * GP cart fix (2026-10-13): the 1-pair cart.
 * Problem seen in Clarity + on the phone: the first Add to Cart opens the optimistic "shell" drawer from gp-cart-instant.js
 * (one line, no offer row, no free-pair carousel, big empty white area) and the real server render sometimes never replaces it.
 * Shoppers read it as "$69 for one pair" and leave.
 * Fix, without touching gp-cart-instant.js:
 *  1. The shell gets the offer row ("ADD 2 MORE PAIRS — THEY'RE FREE · FREE SHIPPING" + 3-step bar) and a "pick your free pairs"
 *     link the moment it appears, so the cart never looks like a single $69 pair.
 *  2. A watchdog: while a predicted (optimistic) row is still on screen 1.2s after the tap, the drawer is re-read from the
 *     server (update_cart_content), again at 3s and 6s. A stale shell can no longer survive.
 *  3. On drawer open / tab focus, the same check runs.
 */
(function () {
  if (window.GPCartFix) return;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  var drawer = function () { return document.getElementById('shopify-section-cart-drawer'); };
  var GP = function () { return window.GPPrice && window.GPPrice.ready ? window.GPPrice : null; };
  var ALL_URL = '/collections/all-sunglasses-copy';

  // ---------- 1. dress the optimistic shell ----------
  function stepText(n) {
    var gp = GP(); var t = gp && gp.text && gp.text.step ? gp.text.step[String(Math.min(Math.max(n, 0), 4))] : '';
    return t || (n >= 3 ? '✓ BUY 1 GET 2 FREE UNLOCKED · FREE SHIPPING' : n === 2 ? 'ADD 1 MORE PAIR — IT’S FREE · FREE SHIPPING' : 'ADD 2 MORE PAIRS — THEY’RE FREE · FREE SHIPPING');
  }
  function pairsInDrawer(d) {
    var n = 0;
    Array.prototype.forEach.call(d.querySelectorAll('.cart_drawer_item'), function (r) {
      if (r.style.display === 'none') return;
      n += +r.getAttribute('data-gp-qty') || +((r.querySelector('.cart_drawer_item_quantity') || {}).textContent) || 1;
    });
    return n;
  }
  function dressShell() {
    var d = drawer(); if (!d) return;
    var shell = $('.gp-opt-shell', d); if (!shell) return;
    var holder = $('.section_holder', d); var main = $('.gp3-main', d) || $('.cart_drawer_main_container', d);
    if (!holder || !main) return;
    var n = pairsInDrawer(d);
    var txt = stepText(n); var parts = txt.split(' · ');
    if (!$('.gp3-progress', d)) {
      var bar = '';
      for (var i = 1; i <= 3; i++) bar += '<span class="gp-step' + (n >= i ? ' on' : '') + '"></span>';
      var html = '<div class="gp3-progress gp-offer gp-fix-progress' + (n >= 3 ? ' is-done' : '') + '" data-gp-header>' +
        '<div class="gp-offer-row gp3-progress__row' + (n >= 3 ? ' is-done' : '') + '" data-gp-scope="b1g2">' +
        '<p class="gp-offer-sub gp3-progress__text"><span class="gp3-progress__main">' + esc(parts[0]) + '</span>' + (parts.length > 1 ? ' <span class="gp3-progress__ship">· ' + esc(parts.slice(1).join(' · ')) + '</span>' : '') + '</p>' +
        '<div class="gp3-progress__bar" aria-hidden="true">' + bar + '</div></div></div>';
      main.insertAdjacentHTML('beforebegin', html);
    }
    if (!$('.gp-fix-pick', d) && !$('.gp3-car', d)) {
      var lines = $('.gp3-lines', d) || $('.cart_drawer_items', d);
      var pick = '<div class="gp3-car gp-fix-pick" style="padding:12px 16px 12px!important">' +
        '<div class="gp3-car__headrow" style="margin:0!important"><div class="gp3-car__head">' + (n >= 3 ? 'YOUR FREE PAIRS ARE IN' : 'ADD A PAIR · IT’S FREE') + '</div>' +
        '<a class="gp3-car__all" href="' + ALL_URL + '" onclick="if(typeof close_slider_cart===\'function\')close_slider_cart()">Pick your free pairs &rarr;</a></div></div>';
      if (lines) lines.insertAdjacentHTML('afterend', pick); else main.insertAdjacentHTML('beforeend', pick);
    }
  }

  // ---------- 2. watchdog: a predicted row must be replaced by the server render ----------
  var timers = [], tries = 0, armedAt = 0;
  function stale() {
    var d = drawer(); if (!d) return false;
    return !!(d.querySelector('[data-gp-optimistic]') || d.querySelector('.gp-opt-shell'));
  }
  function resync(why) {
    if (!stale()) return;
    tries++;
    try { if (window.console && /gp_debug/.test(location.search)) console.warn('[GPCartFix] resync', why, tries); } catch (e) {}
    if (typeof window.update_cart_content === 'function') { try { window.update_cart_content(); } catch (e) {} }
  }
  function arm() {
    armedAt = Date.now(); tries = 0;
    timers.forEach(clearTimeout); timers = [];
    [1200, 3000, 6000, 10000].forEach(function (ms) { timers.push(setTimeout(function () { resync(ms + 'ms'); }, ms)); });
  }
  // any cart add (predicted row inserted) arms the watchdog; the shell is dressed at once
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var a = muts[i].addedNodes;
      for (var j = 0; j < a.length; j++) {
        var nd = a[j]; if (nd.nodeType !== 1) continue;
        var hit = (nd.matches && (nd.matches('[data-gp-optimistic], .gp-opt-shell') || (nd.querySelector && nd.querySelector('[data-gp-optimistic], .gp-opt-shell'))));
        if (hit) { dressShell(); if (!armedAt || Date.now() - armedAt > 800) arm(); return; }
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('gp:optimistic', function () { dressShell(); arm(); });

  // ---------- 3. drawer open / tab back: never show a stale shell ----------
  function onOpen() { dressShell(); if (stale() && Date.now() - armedAt > 1200) resync('open'); }
  (function watchOpen() {
    var d = drawer(); if (!d) { document.addEventListener('DOMContentLoaded', watchOpen); return; }
    var was = d.classList.contains('slided');
    new MutationObserver(function () { var on = d.classList.contains('slided'); if (on && !was) setTimeout(onOpen, 300); was = on; }).observe(d, { attributes: true, attributeFilter: ['class'] });
  })();
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible' && stale()) resync('visible'); });
  window.addEventListener('pageshow', function () { setTimeout(function () { if (stale()) resync('pageshow'); }, 400); });

  window.GPCartFix = { version: 1, dressShell: dressShell, resync: resync, stale: stale };
})();
